import { Phone, Mail } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, SERVICE_AREA, EMAIL_URL, EMAIL_DISPLAY } from "@/lib/contact";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-fog py-12 pb-24 md:pb-12">
    <div className="px-6 flex flex-wrap justify-between gap-4 mo text-sm">
      <span>rosszkanape-elszallitas.hu</span>
      <span data-testid="footer-service-area">{SERVICE_AREA}</span>
      <a href={EMAIL_URL} data-testid="footer-email">{EMAIL_DISPLAY}</a>
      <a href={PHONE_TEL} data-testid="footer-phone">{PHONE_DISPLAY}</a>
    </div>
  </footer>
);

export const MobileBar = () => (
  <div data-testid="mobile-bar" className="fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 md:hidden mo text-sm border-t-2 border-ink">
    <a href={PHONE_TEL} data-testid="mobile-call-button" className="bg-signal text-ink inline-flex items-center justify-center gap-2 py-4 border-r-2 border-ink">
      <Phone className="w-4 h-4" aria-hidden="true" /> Hívás
    </a>
    <a href={EMAIL_URL} data-testid="mobile-email-button" className="bg-transport text-white inline-flex items-center justify-center gap-2 py-4">
      <Mail className="w-4 h-4" aria-hidden="true" /> E-mail
    </a>
  </div>
);
